import React from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";

const DisconnectModal = ({ recordId, showDisconnectModal, hideDisconnectModal, disconnect }) => (
  <Modal
    className="ci-popup-modal"
    isOpen={showDisconnectModal}
    toggle={hideDisconnectModal}
    centered
  >
    <ModalBody>
      <div className="ci-popup-head">
        <h2>Disconnect account?</h2>
        <button
          className="ci-popup-close"
          onClick={hideDisconnectModal}
          aria-label="Close"
        >
          ×
        </button>
      </div>
      <p style={{ margin: 0, fontSize: 13, color: "#667085", lineHeight: 1.55 }}>
        You can reconnect this account later. Review your conflict and booking
        calendars after disconnecting.
      </p>
    </ModalBody>

    <ModalFooter>
      <button className="ci-popup-btn-cancel" onClick={hideDisconnectModal}>
        Cancel
      </button>
      <button
        className="ci-popup-btn-primary"
        style={{ background: "#d92d20" }}
        onClick={() => {
          hideDisconnectModal();
          disconnect(recordId);
        }}
      >
        Disconnect
      </button>
    </ModalFooter>
  </Modal>
);

export default DisconnectModal;
